/*
 * @Description:
 * @Autor: dongliangke
 * @Date: 2024-03-28 18:35:50
 * @LastEditors: zhuzhaoyang
 * @LastEditTime: 2024-07-02 16:11:17
 */
import { whiteList } from "./basics.router";
import { Router } from "vue-router";
import Cookies from "js-cookie";
import util from "@/utils/util";
import $axios from "@/global/request";
import { userStore } from "@/store/modules/user";

// 延迟获取 store，避免在 Pinia 安装前调用（会导致 getActivePinia 报错）
const getStore = () => userStore();

// 权限验证
export const permission = (router: Router) => {
  router.beforeEach((to, from, next) => {
    // 多租户 从url取租户名称
    if ((window as any).serverConfig.IS_MULTI_TENANCY) {
      if (to.query.tenantName) {
        localStorage.setItem(
          "tenantName",
          JSON.parse(JSON.stringify(to.query.tenantName)),
        );
      }
      if (to.path === "/login" && !to.fullPath.includes("tenantName")) {
        let tenantName = "PAI_Core";
        let tName = localStorage.getItem("tenantName");
        if (tName) {
          tenantName = tName;
        }
        localStorage.setItem("tenantName", tenantName);
        let placeholder = to.fullPath.indexOf("?") === -1 ? "?" : "&";
        to.fullPath = to.fullPath + placeholder + "tenantName=" + tenantName;
      }
    }
    // 白名单
    if (whiteList.includes(to.path)) {
      next();
    } else {
      const param = util.getRequestParam(window.parent.location.href);
      // 如果是蒙牛的钉钉对接，需特殊处理逻辑
      if (param.sourceType === "dingTalk") {
        autoLoginByDingCode((info: any) => {
          if (info.code) {
            // 根据钉钉code 获取用户登录信息
            autoLoginByDingdingCode(info.code)
              .then((response) => {
                next();
              })
              .catch((error) => {
                throw error;
              });
          }
        }, param.corpId);
      } else {
        // 获取 paiToken，参考 pai-portal 逻辑：paiToken 不存在或过期时调用 AutoLogin
        let paiToken: { jti?: string; expires_in?: number } | null = null;
        const tokenStr = localStorage.getItem("PAI-token");
        if (tokenStr) {
          try {
            paiToken = JSON.parse(tokenStr);
          } catch {
            paiToken = null;
          }
        }
        const locationHref = window.parent?.location?.href || location.href;
        const param = util.getRequestParam(locationHref) || {};

        // 判断 paiToken 是否有效：存在、未过期、tokenId/wwid 一致（与 pai-portal 一致）
        const isTokenValid = (): boolean => {
          if (!paiToken || !paiToken.expires_in) return false;
          const tokenId = Cookies.get("tokenId");
          const account = localStorage.getItem("PAI-account");
          let login = "";
          if (account) {
            try {
              const accountObj = JSON.parse(account);
              login = accountObj?.login || "";
            } catch {}
          }
          if (
            (tokenId && tokenId !== paiToken.jti) ||
            (param?.wwid && param.wwid !== login)
          ) {
            return false;
          }
          const curTime = new Date().getTime();
          const loginTime = localStorage.getItem("Login-time");
          const expiresIn = paiToken.expires_in * 1000;
          if (!loginTime) return false;
          if (Number(loginTime) + Number(expiresIn) - 7200000 < curTime) {
            return false;
          }
          return true;
        };

        if (paiToken && isTokenValid()) {
          next();
        } else {
          // 判断 tokenId 登录
          let tokenId = Cookies.get("tokenId");
          if (tokenId) {
            // 获取租户名
            const tenantName = util.getUrlParam("tenantName");
            let headers = null;
            if (tenantName) {
              headers = {
                tenantName: tenantName,
              };
            }
            // tokenId 自动登录
            getStore()
              .loginByTokenId(headers, { tokenId: tokenId })
              .then((res) => {
                Cookies.remove("tokenId");

                next();
              })
              .catch((err) => {
                Cookies.remove("tokenId");
                Cookies.remove("loginname");
                // 跳转login判断
                handelNext(to, next);
              });
          } else {
            // 跳转login判断
            handelNext(to, next);
          }
        }
      }
    }
  });
};
/**
 * @FunctionName: 跳转login判断
 * @param {any} to
 * @param {any} next
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2024-07-02 15:47:24
 * @Description:
 */
function handelNext(to: any, next: any) {
  if ((window as any).serverConfig.IS_SSO) {
    location.reload();
  } else {
    // 多租户
    if ((window as any).serverConfig.IS_MULTI_TENANCY) {
      if (to.query && to.query.tenantName) {
        next({ path: "/login", query: { redirect: to.fullPath } });
      } else {
        let tenantName = "PAI_Core";
        let tName = localStorage.getItem("tenantName");
        if (tName) {
          tenantName = tName;
        }
        localStorage.setItem("tenantName", tenantName);
        next({
          path: "/login",
          query: { redirect: to.fullPath, tenantName: tenantName },
        });
      }
    } else {
      next({ path: "/login", query: { redirect: to.fullPath } });
    }
  }
}
/**
 * @FunctionName: 获取钉钉code
 * @Author: zhuzhaoyang
 * @Date: 2021-11-25 13:36:04
 * @Modification history:
 * @Description: 集成钉钉 认证授权
 */
function autoLoginByDingCode(cb: any, corpId: any) {
  (window as any).dd.ready(function () {
    (window as any).dd.runtime.permission.requestAuthCode({
      // 企业id
      corpId: corpId,
      onSuccess: function (info: any) {
        cb(info);
      },
      onFail: function (err: any) {
        // 调用失败时回调
        console.log("dingTalk JS-API认证授权失败：" + err);
      },
    });
  });
}
/**
 * @FunctionName: 根据钉钉code自动登录
 * @param {*} cb
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2021-11-25 14:13:13
 * @Modification history:
 * @Description:
 */
export function autoLoginByDingdingCode(code: any) {
  return new Promise(function (resolve, reject) {
    $axios({
      url:
        (window as any).serverConfig.BASE_API +
        "mengniu-mobile-sso/api/ding-talk-Login",
      method: "post",
      data: {
        code: code,
      },
    })
      .then((result: any) => {
        if (result && result.responseCode === "100") {
          localStorage.setItem("PAI-token", JSON.stringify(result.token));
          localStorage.setItem("Login-time", new Date().getTime().toString());
          localStorage.setItem("PAI-account", JSON.stringify(result.userInfo));
          getStore().setEmployee(result.userInfo);
          resolve(result);
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}
